import { registerComponents } from './vue-utils';
import * as components from './components';

// Export the components as a Vue plugin.
export default {
    install(Vue: any, options?: { components?: string[] }) {
        const includeComponents = options != null && Array.isArray(options.components) && options.components || undefined;
        registerComponents(Vue, components, includeComponents);
    }
}
